import React from "react";
import "./index.scss";

const ErrorMessage = ({ message}) => {
  return <p className="input-error mb-0 mx-3">{message}</p>
};

export default ErrorMessage;
